import React from 'react'
import styled from 'styled-components'

import { PDFDownloadLink, Document, Page, View, StyleSheet, Text } from '@react-pdf/renderer'
import { Icon } from '.'

const StyledButton = styled(PDFDownloadLink)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    width: 120px !important;
    height: 40px !important;
    font-size: 10px !important;
    background-color: ${props => props.theme.colors.success};

    &:hover {
        text-decoration: none;
        background-color: ${props => props.theme.colors.success};
    }
`

const Title = styled.span`
    padding-top: 3px;
    color: white;
    text-decoration: none;
    font-size: 12px;

`

const styles = StyleSheet.create({
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableCol: {
        width: "25%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10
    }
});

const MyDoc = ({ headers, data }) => (
    <Document>
        <Page style={styles.body}>
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    {headers.map((header, index) => (
                        <View style={styles.tableCol} key={index}>
                            <Text style={styles.tableCell}>{header.label}</Text>
                        </View>
                    ))}
                </View>
                {data.map((row, rowIndex) => (
                    <View style={styles.tableRow} key={rowIndex}>
                        {headers.map((header, headerIndex) => (
                            <View style={styles.tableCol} key={headerIndex}>
                                <Text style={styles.tableCell}>{row[header.key]}</Text>
                            </View>
                        ))}
                    </View>
                ))}
            </View>
        </Page>
    </Document> 
);

export const PDFButton = ({ headers, data, title }) => (
    <StyledButton document={<MyDoc headers={headers} data={data} />} fileName={`${title}.pdf`}>
        {({ blob, url, loading, error }) => {
            if (loading) return (
                <>
                    <Icon name={'csv'} />
                    <Title>Carregando...</Title>
                </>
            )
            else return (
                <>
                    <Icon name={'pdf'} />
                    <Title>Exportar PDF</Title>
                </>
            )
        }}
    </StyledButton>
)